import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import CurrencyProp from '../../../profile/propTypes/currencyProp';
import { newFormatPrice } from '../../../../services/utilityFunctions';

function GlobalSummary(props) {
  const { t, data, currentBinaryCommission, monthlyCapping } = props;

  const { isActive, percentageCommission, currencyInfo } = data;
  const progress = Math.max(
    ((currentBinaryCommission || 0) / (monthlyCapping || 1)) * 100,
    0,
  )?.toFixed(2);

  return (
    <div className="grid-row" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
      <div className="grid-item">
        <div className="card card-light-gray">
          <div className="summary-card neofin-summary">
            <div className="summary-media">
              <img
                src="/images/reports/user-summary.svg"
                alt="active"
                className="summary-image"
              />
            </div>
            <div className="summary-content">
              <div className="summary-section">
                <span className="summary-name">
                  {t('report.neofin.summary')}
                </span>
              </div>
              <div className="d-flex">
                <div className="summary-action">
                  <div className="summary-action-content">
                    <span className="summary-action-label">
                      {t('report.neofin.status')}
                    </span>
                    <label htmlFor="isActive" className="checkbox">
                      <input
                        name="isActive"
                        type="checkbox"
                        className="summary-checkbox"
                        disabled
                        checked={isActive}
                      />
                      <label htmlFor="isActive" className="fakeCheckbox" />
                      <span className="isActiveLabel">
                        {t('report.neofin.isActive')}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid-item">
        <div className="card percentage-commissions">
          <div className="percentage-commissions-card">
            <div className="d-flex">
              <div className="small-image-container">
                <img
                  src="/images/reports/percentage.svg"
                  alt="active"
                  className="summary-image"
                />
              </div>
              <span className="small-text">
                {t('report.neofin.percentageCommission')}
              </span>
            </div>
            <span className="small-text">
              {`${percentageCommission}% ${t(
                'report.neofin.percentageCommissionLeg',
              )}`}
            </span>
          </div>
        </div>
      </div>
      <div className="grid-item">
        <div className="card card-light-gray weekly-cap-card">
          <div className="card-body">
            <div className="d-flex">
              <div className="small-image-container">
                <img
                  src="/images/reports/calendar.svg"
                  alt="active"
                  className="summary-image"
                />
              </div>
              <span className="value-label weekly-capping">
                {t('report.neofin.weeklyCapping')}
              </span>
            </div>

            <p style={{ marginBottom: '5px' }}>
              {t(
                'report.neofin.binaryCommission',
                currentBinaryCommission
                  ? `${newFormatPrice(
                      currentBinaryCommission,
                      true,
                      currencyInfo?.code,
                    )}`
                  : '-',
              )}
            </p>

            <p style={{ marginBottom: '5px' }}>
              {t(
                'report.neofin.monthlyCapping',
                monthlyCapping
                  ? `${newFormatPrice(
                      monthlyCapping,
                      true,
                      currencyInfo?.code,
                    )}`
                  : '-',
              )}
            </p>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                width: '100%',
              }}
            >
              <div
                className="progress"
                style={{
                  width: '100%',
                  height: '26px',
                  borderRadius: '15px',
                  position: 'relative',
                  marginBottom: 0,
                  flex: 1,
                }}
              >
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${progress}%`,
                  }}
                />
              </div>
              <div
                style={{
                  color: 'black',
                  top: '13px',
                  left: '10px',
                  fontSize: '1.2rem',
                  margin: 0,
                }}
              >
                {progress}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

GlobalSummary.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    isActive: PropTypes.bool,
    activeUntilDate: PropTypes.string,
    isBusinessLicenseActive: PropTypes.bool,
    businessLicenseActiveUntilDate: PropTypes.string,
    percentageCommission: PropTypes.number,
    weeklyCapping: PropTypes.number,
    currencyInfo: PropTypes.shape(CurrencyProp.propType),
  }).isRequired,
  currentBinaryCommission: PropTypes.number,
  monthlyCapping: PropTypes.number,
};
GlobalSummary.defaultProps = {
  currentBinaryCommission: null,
  monthlyCapping: null,
};

export default translate(GlobalSummary);
